export enum Roles {
  Administrator = 'Administrator',
  User = 'User',
  InstallationUser = 'Installation User',
  InternalAdministrator = 'Internal Administrator'
}
